const FacebookLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path
        d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z"
        fill="white"
      ></path>{" "}
    </svg>
  );
};
const InstagramLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      {" "}
      <path
        d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z"
        fill="white"
      ></path>{" "}
    </svg>
  );
};
const TwitterLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      {" "}
      <path
        d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15z"
        fill="white"
      ></path>{" "}
    </svg>
  );
};
const YoutubeLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      {" "}
      <path
        d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408L6.4 5.209z"
        fill="white"
      ></path>{" "}
    </svg>
  );
};
const PhoneIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.62 7.79C5.06 10.62 7.38 12.93 10.21 14.38L12.41 12.18C12.68 11.91 13.08 11.82 13.43 11.94C14.55 12.31 15.76 12.51 17 12.51C17.55 12.51 18 12.96 18 13.51V17C18 17.55 17.55 18 17 18C7.61 18 0 10.39 0 1C0 0.45 0.45 0 1 0H4.5C5.05 0 5.5 0.45 5.5 1C5.5 2.25 5.7 3.45 6.07 4.57C6.18 4.92 6.1 5.31 5.82 5.59L3.62 7.79Z"
        fill="#8B8A6D"
      />
    </svg>
  );
};
const BackArrow = () => {
  return (
    <svg height="25" version="1.1" viewBox="0 0 512 512" width="25">
      <polygon points="352,128.4 319.7,96 160,256 160,256 160,256 319.7,416 352,383.6 224.7,256 " />
    </svg>
  );
};
const PersonalIcon = () => {
  return (
    <svg
      width="39"
      height="44"
      viewBox="0 0 39 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.5 4.4C15.9101 4.4 13 7.35492 13 11C13 14.6451 15.9101 17.6 19.5 17.6C23.0898 17.6 26 14.6451 26 11C26 7.35493 23.0898 4.4 19.5 4.4ZM8.66667 11C8.66667 4.92487 13.5169 0 19.5 0C25.483 0 30.3333 4.92485 30.3333 11C30.3333 17.0751 25.483 22 19.5 22C13.5169 22 8.66667 17.0751 8.66667 11ZM15.1667 28.6C9.18358 28.6 4.33333 33.5249 4.33333 39.6V41.8C4.33333 43.015 3.36328 44 2.16667 44C0.97005 44 0 43.015 0 41.8V39.6C0 31.0948 6.79034 24.2 15.1667 24.2H23.8333C32.2096 24.2 39 31.0948 39 39.6V41.8C39 43.015 38.0299 44 36.8333 44C35.6367 44 34.6667 43.015 34.6667 41.8V39.6C34.6667 33.5249 29.8164 28.6 23.8333 28.6H15.1667Z"
        fill="#8B8A6D"
      />
    </svg>
  );
};
const CollectiveIcon = () => {
  return (
    <svg
      width="95"
      height="44"
      viewBox="0 0 95 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M47.5 4.4C43.9101 4.4 41 7.35492 41 11C41 14.6451 43.9101 17.6 47.5 17.6C51.0898 17.6 54 14.6451 54 11C54 7.35493 51.0898 4.4 47.5 4.4ZM36.6667 11C36.6667 4.92487 41.5169 0 47.5 0C53.483 0 58.3333 4.92485 58.3333 11C58.3333 17.0751 53.483 22 47.5 22C41.5169 22 36.6667 17.0751 36.6667 11ZM43.1667 28.6C37.1836 28.6 32.3333 33.5249 32.3333 39.6V41.8C32.3333 43.015 31.3633 44 30.1667 44C28.97 44 28 43.015 28 41.8V39.6C28 31.0948 34.7903 24.2 43.1667 24.2H51.8333C60.2096 24.2 67 31.0948 67 39.6V41.8C67 43.015 66.03 44 64.8333 44C63.6367 44 62.6667 43.015 62.6667 41.8V39.6C62.6667 33.5249 57.8164 28.6 51.8333 28.6H43.1667Z"
        fill="#8B8A6D"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M75.5 4.4C71.9101 4.4 69 7.35492 69 11C69 14.6451 71.9101 17.6 75.5 17.6C79.0898 17.6 82 14.6451 82 11C82 7.35493 79.0898 4.4 75.5 4.4ZM64.6667 11C64.6667 4.92487 69.5169 0 75.5 0C81.483 0 86.3333 4.92485 86.3333 11C86.3333 17.0751 81.483 22 75.5 22C69.5169 22 64.6667 17.0751 64.6667 11ZM71.1667 28.6C65.1836 28.6 60.3333 33.5249 60.3333 39.6V41.8C60.3333 43.015 59.3633 44 58.1667 44C56.97 44 56 43.015 56 41.8V39.6C56 31.0948 62.7903 24.2 71.1667 24.2H79.8333C88.2096 24.2 95 31.0948 95 39.6V41.8C95 43.015 94.03 44 92.8333 44C91.6367 44 90.6667 43.015 90.6667 41.8V39.6C90.6667 33.5249 85.8164 28.6 79.8333 28.6H71.1667Z"
        fill="#8B8A6D"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.5 4.4C15.9101 4.4 13 7.35492 13 11C13 14.6451 15.9101 17.6 19.5 17.6C23.0898 17.6 26 14.6451 26 11C26 7.35493 23.0898 4.4 19.5 4.4ZM8.66667 11C8.66667 4.92487 13.5169 0 19.5 0C25.483 0 30.3333 4.92485 30.3333 11C30.3333 17.0751 25.483 22 19.5 22C13.5169 22 8.66667 17.0751 8.66667 11ZM15.1667 28.6C9.18358 28.6 4.33333 33.5249 4.33333 39.6V41.8C4.33333 43.015 3.36328 44 2.16667 44C0.97005 44 0 43.015 0 41.8V39.6C0 31.0948 6.79034 24.2 15.1667 24.2H23.8333C32.2096 24.2 39 31.0948 39 39.6V41.8C39 43.015 38.03 44 36.8333 44C35.6367 44 34.6667 43.015 34.6667 41.8V39.6C34.6667 33.5249 29.8164 28.6 23.8333 28.6H15.1667Z"
        fill="#8B8A6D"
      />
    </svg>
  );
};
const LoadingIcon = () => {
  return (
    <svg
      width="100"
      height="100"
      viewBox="0 0 172 172"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="137" cy="38" r="12" fill="#8B8A6D" fill-opacity="0.1" />
      <circle cx="157" cy="75" r="15" fill="#8B8A6D" fill-opacity="0.2" />
      <circle cx="152" cy="116" r="16" fill="#8B8A6D" fill-opacity="0.3" />
      <circle cx="121" cy="148" r="17" fill="#8B8A6D" fill-opacity="0.4" />
      <circle cx="75.5" cy="154.5" r="17.5" fill="#8B8A6D" fill-opacity="0.5" />
      <circle cx="34.5" cy="130.5" r="18.5" fill="#8B8A6D" fill-opacity="0.6" />
      <circle cx="19.5" cy="84.5" r="19.5" fill="#8B8A6D" fill-opacity="0.9" />
      <circle cx="40.5" cy="39.5" r="20.5" fill="#8B8A6D" />
      <circle cx="91.5" cy="21.5" r="21.5" fill="#8B8A6D" />
    </svg>
  );
};
const WhatsAppLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path d="M 12.011719 2 C 6.5057187 2 2.0234844 6.478375 2.0214844 11.984375 C 2.0204844 13.744375 2.4814687 15.462563 3.3554688 16.976562 L 2 22 L 7.2324219 20.763672 C 8.6914219 21.559672 10.333859 21.977516 12.005859 21.978516 L 12.009766 21.978516 C 17.514766 21.978516 21.995047 17.499141 21.998047 11.994141 C 22.000047 9.3251406 20.962172 6.8157344 19.076172 4.9277344 C 17.190172 3.0407344 14.683719 2.001 12.011719 2 z M 12.009766 4 C 14.145766 4.001 16.153109 4.8337969 17.662109 6.3417969 C 19.171109 7.8517969 20.000047 9.8581875 19.998047 11.992188 C 19.996047 16.396187 16.413812 19.978516 12.007812 19.978516 C 10.674812 19.977516 9.3544062 19.642812 8.1914062 19.007812 L 7.5175781 18.640625 L 6.7734375 18.816406 L 4.8046875 19.28125 L 5.2851562 17.496094 L 5.5019531 16.695312 L 5.0878906 15.976562 C 4.3898906 14.768562 4.0204844 13.387375 4.0214844 11.984375 C 4.0234844 7.582375 7.6067656 4 12.009766 4 z M 8.4765625 7.375 C 8.3095625 7.375 8.0395469 7.4375 7.8105469 7.6875 C 7.5815469 7.9365 6.9355469 8.5395781 6.9355469 9.7675781 C 6.9355469 10.995578 7.8300781 12.182609 7.9550781 12.349609 C 8.0790781 12.515609 9.68175 15.115234 12.21875 16.115234 C 14.32675 16.946234 14.754891 16.782234 15.212891 16.740234 C 15.670891 16.699234 16.690438 16.137687 16.898438 15.554688 C 17.106437 14.971687 17.106922 14.470187 17.044922 14.367188 C 16.982922 14.263188 16.816406 14.201172 16.566406 14.076172 C 16.317406 13.951172 15.090328 13.348625 14.861328 13.265625 C 14.632328 13.182625 14.464828 13.140625 14.298828 13.390625 C 14.132828 13.640625 13.655766 14.201187 13.509766 14.367188 C 13.363766 14.534188 13.21875 14.556641 12.96875 14.431641 C 12.71875 14.305641 11.914938 14.041406 10.960938 13.191406 C 10.218937 12.530406 9.7182656 11.714844 9.5722656 11.464844 C 9.4272656 11.215844 9.5585938 11.079078 9.6835938 10.955078 C 9.7955938 10.843078 9.9316406 10.663578 10.056641 10.517578 C 10.180641 10.371578 10.223641 10.267562 10.306641 10.101562 C 10.389641 9.9355625 10.347156 9.7890625 10.285156 9.6640625 C 10.223156 9.5390625 9.737625 8.3065 9.515625 7.8125 C 9.328625 7.3975 9.131125 7.3878594 8.953125 7.3808594 C 8.808125 7.3748594 8.6425625 7.375 8.4765625 7.375 z"></path>
    </svg>
  );
};
const DownloadIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="feather feather-download"
      viewBox="2 2 20 20"
    >
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
      <polyline points="7 10 12 15 17 10"></polyline>
      <line x1="12" y1="15" x2="12" y2="3"></line>
    </svg>
  );
};
export {
  FacebookLogo,
  InstagramLogo,
  TwitterLogo,
  YoutubeLogo,
  PhoneIcon,
  BackArrow,
  PersonalIcon,
  CollectiveIcon,
  LoadingIcon,
  WhatsAppLogo,
  DownloadIcon,
};
